import type { TSelectProps } from "./Select";

/**
 * Bridges custom react-select subcomponents (often typed with extended option shapes)
 * to the shared Select wrapper's components prop.
 */
export function asSelectComponents(
  components: unknown,
): NonNullable<TSelectProps["components"]> {
  return components as NonNullable<TSelectProps["components"]>;
}
